import React from 'react';

import { Container, Typography, Button } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import HeaderFooterShell from '@hydra/common/shell/HeaderFooterShell';
import { Translate } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(4),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius * 2.5,
    padding: 0,
    backgroundColor: theme.palette.background.paper
  },
  header: {
    display: 'flex',
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    justifyContent: 'space-between',
    padding: theme.spacing(3),
    paddingLeft: theme.spacing(4.5)
  },
  heading: {
    margin: theme.spacing(1, 0),
    fontWeight: theme.typography.fontWeightSemibold
  },
  content: {
    padding: theme.spacing(3)
  },
  button: {
    margin: theme.spacing(2)
  }
}));

export default function WebflowContainer ({ data }: {
  data: { authUrl?: string, accessToken?: string | null }
}) {
  const theme = useTheme();
  const classes = useStyles();
  return (
    <HeaderFooterShell
      bgColor={theme.palette.background.secondary}
      hideHeader
      FooterProps={{
        small: false
      }}
    >
      <Container maxWidth='lg' className={classes.root}>
        <div className={classes.header}>
          <div>
            <Typography component='h3' variant='h3' className={classes.heading}>
              <Translate content='cms_webflow_getting_started_installed_title' />
            </Typography>
            <Typography>
              <Translate content='cms_webflow_getting_started_installed_subtitle' />
            </Typography>
          </div>
          <div className={classes.button}>
            <Button
              variant='contained'
              color='primary'
              size='large'
              href='https://webflow.com/dashboard'
              target='_blank'
              rel='nofollow noopener noreferrer'
            >
              Webflow
            </Button>
          </div>
        </div>
      </Container>
    </HeaderFooterShell>
  );
}
